import { ClassData, JackRabbitClassesDataResponse } from "../dtos/classes.type";
import { APP_VERSION } from "./default-category.service";
import { trackingService } from "./tracking.service";

/**
 * A singleton that stores the list of data fetched from the server.
 *
 * Provides simple filtering options for the data;
 *
 */
class RYBConnectEvents {
  public static instance: RYBConnectEvents;
  private isLoading: boolean = false;
  private data: null | ClassData[] = null;
  private loadPromise: null | Promise<ClassData[]> = null;
  private CAMPS_FILTER = "Camp";
  private PARENTS_NIGHT_OUR_FILTER = "Parents Night Out";
  private CLINIC_FILTER = "Clinic";
  private HOME_OF_FIT_KIDS_FILTER = "Home School";
  private SCL_PRESCHOOL = "SCL Preschool";

  constructor() {
    if (RYBConnectEvents.instance) {
      return RYBConnectEvents.instance;
    }
    trackingService.init();
    console.log(`RYB Connect ${APP_VERSION}`);
    RYBConnectEvents.instance = this;
  }

  /**
   * Get's unfiltered data from the API or from the instance
   * @returns {data}
   */
  async getData() {
    if (this.data) {
      return this.data;
    }

    if (this.isLoading) {
      return this.loadPromise;
    }

    this.isLoading = true;
    this.loadPromise = new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(
          ryb_connect_connection_details?.url ||
            "ryb_connect_connection_details?.url is not defined",
          {
            method: "GET",
          }
        );

        const data: JackRabbitClassesDataResponse = await response.json();
        if (data.success) {
          this.data = data.rows;
          this.isLoading = false;
          resolve(this.data);
        } else {
          this.isLoading = false;
          trackingService.captureException(
            new Error(
              `${window.location.host} | Jackrabbit respond with error in category shortcode`
            ),
            {
              requestedUrl:
                ryb_connect_connection_details?.url ||
                "ryb_connect_connection_details?.url is not defined",
              devMessage: "Jackrabbit returned error",
              response: data,
            }
          );
          reject("Error: " + data);
        }
      } catch (error) {
        this.isLoading = false;
        trackingService.captureException(
          new Error(
            `${window.location.host} | Exception - Jackrabbit respond with error in category shortcode`
          ),
          {
            requestedUrl:
              (typeof ryb_connect_connection_details !== "undefined" &&
                ryb_connect_connection_details?.url) ||
              "ryb_connect_connection_details?.url is not defined",
            devMessage: "Jackrabbit returned error",
            error: error,
          }
        );
        reject("Error: Unable to fetch class openings.");
      }
    });

    return this.loadPromise;
  }

  // @note: deprecated - to be removed
  async getCamps() {
    const data = await this.getData();
    return data?.filter((item) => item.category1 === this.CAMPS_FILTER);
  }

  // @note: deprecated - to be removed
  async getParentsNightOut() {
    const data = await this.getData();
    return data?.filter(
      (item) => item.category1 === this.PARENTS_NIGHT_OUR_FILTER
    );
  }

  // @note: deprecated - to be removed
  async getClinic() {
    const data = await this.getData();
    return data?.filter((item) => item.category1 === this.CLINIC_FILTER);
  }

  // @note: deprecated - to be removed
  async getHomeOfFitKids() {
    const data = await this.getData();
    return data?.filter(
      (item) => item.category1 === this.HOME_OF_FIT_KIDS_FILTER
    );
  }

  // @note: deprecated - to be removed
  async getSCLPreschool() {
    const data = await this.getData();
    return data?.filter((item) => item.category1 === this.SCL_PRESCHOOL);
  }

  async getShortcodeData(filterKey: string, filterValues: string[]) {
    const data = await this.getData();
    const result = [];

    for (const filterValue of filterValues) {
      const filteredData = data?.filter(
        (item: any) => item[filterKey] === filterValue
      );
      if (filteredData) {
        result.push(...filteredData);
      }
    }

    return result;
  }
}

export default RYBConnectEvents;
